import historyProvider from './history-provider';
import stream from './stream';

const supportedResolutions = ['1', '5', '15', '30', '60', '120', '180', 'D'];

import { SharedData } from './../shared-data';

import { AppEndPoints } from 'src/config/end-points.constants';

const API_URL = AppEndPoints.NSE_SYMBOL_DATA;

const config = {
  supported_resolutions: supportedResolutions,
};

// @ts-ignore
export default {
  onReady: (cb: any) => {
    setTimeout(() => {
      cb({
        supported_resolutions: supportedResolutions,
      });
    }, 0);
  },

  searchSymbols: (
    userInput: string,
    exchange: string,
    symbolType: string,
    onResultReadyCallback: any
  ) => {
    let broker: any;
    let exchange$ = SharedData.exchange$;
    exchange$.subscribe({
      next(value) {
        broker = value;
      },
      error(err) {
        console.log(err);
      },
    });
    if (broker == 'ib' || broker == 'ibpaper') {
      if (!userInput) {
        onResultReadyCallback(null);
        return;
      }
      SharedData.ibList$.subscribe({
        next(value) {
          console.log('Received value:', value, typeof value); // <-- check if it's really an array

          if (!Array.isArray(value)) {
            console.error('Expected an array but got:', value);
            onResultReadyCallback([]);
            return;
          }

          const symbols = value
            .filter((item: any) =>
              item.toLowerCase().includes(userInput.toLowerCase())
            )
            .map((item: any) => ({
              symbol: item,
              full_name: item,
              description: item,
              exchange: item,
              type: symbolType,
            }));

          onResultReadyCallback(symbols);
        },
        error(err) {
          onResultReadyCallback([]);
        },
      });
    } else {
      if (!userInput) {
        onResultReadyCallback(null);
        return;
      }
      fetch(API_URL)
        .then((response) => response.json())
        .then((res) => {
          if (res.status !== 'success') {
            console.error('Invalid response structure:', res);
            onResultReadyCallback([]);
            return;
          }

          const jsonData = res.data.result;
          const symbols = jsonData
            .filter((item: any) =>
              item.SYMBOL.toLowerCase().includes(userInput.toLowerCase())
            )
            .map((item: any) => ({
              symbol: item.SYMBOL,
              full_name: item.SYMBOL,
              description: item['NAME OF COMPANY'],
              exchange: exchange || item.Exchange,
              type: symbolType || item.SERIES,
            }));

          onResultReadyCallback(symbols);
        })
        .catch((error) => {
          console.error('Error fetching CSV:', error);
          onResultReadyCallback([]);
        });
    }
  },

  resolveSymbol: (
    symbolName: any,
    onSymbolResolvedCallback: any,
    onResolveErrorCallback: any
  ) => {
    let value$ = SharedData.data$;
    value$.subscribe((ele) => {
      const symbol_stub = {
        name: symbolName,
        description: '',
        type: 'Stocks',
        session: '24x7',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ticker: symbolName,
        exchange: ele.toUpperCase(),
        minmov: 1,
        minmov2: 0,
        pointvalue: 1,
        pricescale: 100,
        has_intraday: true,
        intraday_multipliers: ['1', '5', '15', '30', '60', '120', '180'],
        supported_resolutions: supportedResolutions, // Fixed key name
        volume_precision: 8,
        data_status: 'streaming',
        currency_code: 'INR',
      };

      setTimeout(() => {
        onSymbolResolvedCallback(symbol_stub);
      }, 0);
    });
  },

  getBars: function (
    symbolInfo: any,
    resolution: any,
    from: any,
    to: any,
    onHistoryCallback: any,
    onErrorCallback: any,
    firstDataRequest: any
  ) {
    historyProvider
      .getBars(symbolInfo, resolution, from, to, firstDataRequest, 2000)
      .then((bars: any = []) => {
        // Ensure `bars` is always an array
        onHistoryCallback(bars, { noData: bars.length === 0 });
      })
      .catch((err: any) => {
        console.error('Error fetching bars:', err);
        onErrorCallback(err);
      });
  },

  subscribeBars: (
    symbolInfo: any,
    resolution: any,
    onRealtimeCallback: any,
    subscribeUID: any,
    onResetCacheNeededCallback: any
  ) => {
    stream.subscribeBars(
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscribeUID,
      onResetCacheNeededCallback
    );
  },

  unsubscribeBars: (subscriberUID: any) => {
    stream.unsubscribeBars(subscriberUID);
  },

  calculateHistoryDepth: (
    resolution: any,
    resolutionBack: any,
    intervalBack: any
  ) => {
    return parseInt(resolution, 10) < 60
      ? { resolutionBack: 'D', intervalBack: '1' }
      : undefined;
  },

  getMarks: (
    symbolInfo: any,
    startDate: any,
    endDate: any,
    onDataCallback: any,
    resolution: any
  ) => {},

  getTimeScaleMarks: (
    symbolInfo: any,
    startDate: any,
    endDate: any,
    onDataCallback: any,
    resolution: any
  ) => {},

  getServerTime: (cb: any) => {},
};
